import { render, staticRenderFns } from "./cambioInformacionCliente.vue?vue&type=template&id=b9de2f54&scoped=true&"
import script from "./cambioInformacionCliente.vue?vue&type=script&lang=js&"
export * from "./cambioInformacionCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9de2f54",
  null
  
)

export default component.exports